var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Modal } from '@els/els-react--modal';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { ELSIconV2 } from 'components/common';
import { checkPathMatch } from 'helpers/app.helper';
import { onKeyDownHandler } from 'helpers/ui.helper';
var PageNavigatorModal = function (_a) {
    var navItems = _a.navItems, handleCancel = _a.handleCancel, activePageName = _a.activePageName, isHesiReadinessApp = _a.isHesiReadinessApp, goToEAQReport = _a.goToEAQReport;
    var data = isHesiReadinessApp ? __spreadArray([], navItems.expand, true) : __spreadArray(__spreadArray([], navItems.default, true), navItems.expand, true);
    var navItemElm = data.map(function (item) {
        var name = item.name, paths = item.paths, icon = item.icon, isAlwaysActive = item.isAlwaysActive, onClickCustomLink = item.onClickCustomLink;
        if (onClickCustomLink) {
            return (<div key={name} role="button" tabIndex={0} className="c-page-navigator-modal__item c-page-navigator-modal__item-eaq-topic-report" onClick={function () { return goToEAQReport === null || goToEAQReport === void 0 ? void 0 : goToEAQReport(); }} onKeyDown={function (evt) { return onKeyDownHandler(evt, goToEAQReport); }}>
          {name}
        </div>);
        }
        var match = checkPathMatch(paths);
        return (<Link key={name} className={classNames('c-page-navigator-modal__item', { 'c-page-navigator-modal__item--active': isAlwaysActive || match })} to={paths[0]}>
        {name}
        {icon && <ELSIconV2 sprite={icon} size="s"/>}
      </Link>);
    });
    return (<Modal className="c-page-navigator-modal" label="Page Navigator" onClose={function () { return handleCancel(); }} shouldHideCloseButton>
      <div className="c-page-navigator-modal__content">
        <div className={classNames('c-page-navigator-modal__content-row', { 'c-page-navigator-modal__content-row--justify-center': !activePageName })}>
          {activePageName}
          <button tabIndex={0} type="button" className="u-cursor-pointer c-page-navigator-modal__content-row-close-btn" onClick={function () { return handleCancel(); }} aria-label="Close page navigator">
            <ELSIconV2 sprite="Close" id="page-navigator-modal-close" size="m" isDecorative/>
          </button>
        </div>
        <div className="c-els-divider c-els-divider--1o2"/>
        <div className="u-els-color-secondary c-page-navigator-modal__content-row">Back to My Course Plan</div>
        <div className="c-els-divider c-els-divider--1o2"/>
        <div>{navItemElm}</div>
      </div>
    </Modal>);
};
export default PageNavigatorModal;
